module.exports = __webpack_public_path__ + "static/media/beijing_wenzhen_icon@3x.c89c017e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beijing_wenzhen_icon@3x.png
// module id = 660
// module chunks = 0